import React, { useMemo, useState } from "react";
import { useTranslation } from 'react-i18next';
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import ShareIcon from "@mui/icons-material/Share";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import * as colors from "@mui/material/colors";
import { HOST_URL } from "../../shared/constants";
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";

import { AddPlace } from "../add-place";
import { useSelector } from "react-redux";

export const ShareLocation = (props) => {
  const { pickedLocation } = props;
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [isAddPlaceOpen, setIsAddPlaceOpen] = useState(false);
  const { token } = useSelector((state) => state.auth);
  const URL = useMemo(
    () =>
      `${HOST_URL}/open?lat=${pickedLocation?.[1]}&lng=${pickedLocation?.[0]}`,
    [pickedLocation]
  );
  return (
    <>
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: 80, md: 20 },
          display: "flex",
          width: "100%",
          justifyContent: "center",
          zIndex: 1000,
        }}
      >
        <Box
          sx={{
            boxShadow: 1,
            padding: "10px 20px",
            backgroundColor: colors.common.white,
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
            transition: "0.5s ease-in-out",
            // transform: pickedLocation ? "translateY(0px)" : "translateY(102vh)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Typography variant="caption">
              {pickedLocation?.[0].toFixed(6)}, {pickedLocation?.[1].toFixed(6)}
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                startIcon={<ShareIcon />}
                size="small"
                sx={{
                  backgroundColor: colors.blue[700],
                  color: colors.common.white,
                  textTransform: "none",
                  padding: "5px 15px",
                  borderRadius: "20px",
                  "&:hover": {
                    backgroundColor: colors.blue[600],
                  },
                }}
                onClick={() => setIsOpen(true)}
              >
                {t('Share')}
              </Button>
              {token && (
                <Button
                  startIcon={<AddLocationAltIcon />}
                  size="small"
                  sx={{
                    backgroundColor: colors.teal[700],
                    color: colors.common.white,
                    textTransform: "none",
                    padding: "5px 18px",
                    borderRadius: "20px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    "&:hover": {
                      backgroundColor: colors.teal[600],
                      boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                    },
                  }}
                  onClick={() => setIsAddPlaceOpen(true)}
                >
                  {t('RegisterThisPlace')}
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <Modal open={isOpen} onClose={() => setIsOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            <FacebookShareButton url={URL}>
              <FacebookIcon size={30} />
            </FacebookShareButton>
            <TwitterShareButton url={URL}>
              <TwitterIcon size={30} />
            </TwitterShareButton>
            <EmailShareButton url={URL}>
              <EmailIcon size={30} />
            </EmailShareButton>
            <LinkedinShareButton url={URL}>
              <LinkedinIcon size={30} />
            </LinkedinShareButton>
            <TelegramShareButton url={URL}>
              <TelegramIcon size={30} />
            </TelegramShareButton>
            <WhatsappShareButton url={URL}>
              <WhatsappIcon size={30} />
            </WhatsappShareButton>
            <CopyToClipboard
              text={URL}
              onCopy={() =>
                toast.info(t('LinkCopied'), {
                  position: "bottom-right",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  closeButton: false,
                })
              }
            >
              <Button
                startIcon={<FileCopyOutlinedIcon />}
                size="small"
                sx={{
                  backgroundColor: colors.blue[700],
                  color: colors.common.white,
                  textTransform: "none",
                  padding: "5px 15px",
                  "&:hover": {
                    backgroundColor: colors.blue[600],
                  },
                }}
              >
                {t('Copy')}
              </Button>
            </CopyToClipboard>
          </Box>
        </Box>
      </Modal>
      <AddPlace
        isOpen={isAddPlaceOpen}
        onClose={() => setIsAddPlaceOpen(false)}
        coordinate={pickedLocation}
      />
    </>
  );
};
